import { StringHelper } from '../../../core/helpers/strings.helper';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { WalletService } from '../../../core/services/wallet.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { differenceInCalendarDays } from 'date-fns';
import { saveAs } from 'file-saver';
import * as moment from 'moment';

@Component({
	selector: 'app-wallet-filter-modal',
	templateUrl: './wallet-filter-modal.component.html',
	styleUrls: ['./wallet-filter-modal.component.scss']
})
export class WalletFilterModalComponent implements OnInit {

	tabs = [
		{
			name: 'Today',
			unit: 'day',
			value: '',
			id: 1
		},
		{
			name: 'Last 7 Days',
			unit: 'days',
			value: 7,
			id: 2
		},
		{
			name: 'Last 30 Days',
			unit: 'days',
			value: 30,
			id: 3
		},
		{
			name: '1 Year',
			unit: 'years',
			value: 1,
			id: 4
		},
	];

	format = [
		'PDF',
		'Excel'
	];

	historyDownloadForm: FormGroup;
	selectedTab: any;
	submitting: boolean;
	today = new Date();
	errorMessage: string;
	selectedFileFormat: any;

	constructor(
		private fb: FormBuilder,
		private walletService: WalletService,
		public modal: NzModalRef,
	) {
		this.historyDownloadForm = this.fb.group({
			fileFormat: [null, [Validators.required]],
			startDate: [null, [Validators.required]],
			endDate: [null, [Validators.required]],
		});
	}

	ngOnInit(): void {
		this.historyDownloadForm.patchValue({
			endDate: moment().toDate(),
			fileFormat: this.format[0]
		});
		this.selectDateTab(this.tabs[0]);
	}

	downloadFile() {
		this.submitting = true;
		const params = this.buildDownloadParams();
		this.walletService.downloadHistoryFile(params).then((res: Blob) => {
			saveAs(res, `history.${this.selectedFileFormat}`);
			this.submitting = false;
		}).catch(err => {
			this.submitting = false;
			this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(err);
		});
	}

	buildDownloadParams() {
		const form = this.historyDownloadForm.value;
		this.selectedFileFormat = form.fileFormat.toLowerCase() === 'pdf' ?
			form.fileFormat.toLowerCase() : 'xls';
		const params = {
			StartDate: this.formateDate(form.startDate),
			EndDate: this.formateDate(form.endDate),
			Format: form.fileFormat.toLowerCase()
		};
		return params;
	}

	formateDate(date) {
		const dateValue = `${moment(date).format('YYYY-MM-DD hh:mm:ss')}`;
		return dateValue;
	}

	selectDateTab(value) {
		this.selectedTab = value;
		if (value.id === 1) {
			this.historyDownloadForm.patchValue({ startDate: moment().startOf('day').toDate() });
			return;
		}
		this.historyDownloadForm.patchValue({
			startDate: moment().subtract(this.selectedTab.value, this.selectedTab.unit).toDate()
		});
	}

	disabledDate = (current: Date): boolean => {
		return differenceInCalendarDays(current, this.today) > 0;
	}

}
